import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTokenOps } from './TokenContext';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: '#eef5ff',
    borderBottom: '1px solid #b7cdf4',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    minHeight: 48,
    padding: theme.spacing(1, 2),
    width: '100%',
  },
  context: {
    alignItems: 'baseline',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
  },
  label: {
    fontWeight: 600,
  },
}));

const AccountContextBanner = () => {
  const classes = useStyles();
  const tokenOps = useTokenOps();

  if (!tokenOps.isSwitchAccount) return null;

  const principalName =
    tokenOps.root?.data?.userName ||
    tokenOps.account?.data?.userName ||
    'Internal user';
  const homeAccountName = tokenOps.root?.data?.accountName || 'BCome Internal';
  const activeAccountName =
    tokenOps.account?.data?.accountName || 'selected account';

  return (
    <Box className={classes.root} role="status" aria-live="polite">
      <Box className={classes.context}>
        <Typography component="span" variant="body2" className={classes.label}>
          {principalName}
        </Typography>
        <Typography component="span" variant="body2">
          working in {activeAccountName}
        </Typography>
      </Box>
      <Button
        color="primary"
        size="small"
        onClick={tokenOps.exitAccountToken}
        aria-label={`Return to ${homeAccountName}`}
      >
        Return to {homeAccountName}
      </Button>
    </Box>
  );
};

export default AccountContextBanner;
